module.exports = __webpack_public_path__ + "static/media/transporter-2.69f2eac2.svg";